import styled from "styled-components";
import Video from "../Video/Video";
import Image from "../Image/Image";

export const ModalContainer = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #142743;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 500px;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  padding: 0 16px 0 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 6px;
`;
export const RowIcons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const TabsContainer = styled.div`
  height: 36px;
  border-radius: 100px;
  background: #345884;
  margin-inline: 16px;
  display: flex;
  padding: 2px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: ${({ $activeTab }) =>
      $activeTab === "IMAGE_TO_VIDEO" ? "2px" : "calc(50% + 1px)"};
    width: calc(50% - 2px);
    height: calc(100% - 4px);
    background: white;
    border-radius: 100px;
    transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
  }
`;

export const Tab = styled.div`
  flex: 1;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 100px;
  opacity: ${({ $disabled }) => ($disabled ? 0.2 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ $disabled }) => $disabled && "none"};
  position: relative;
  z-index: 2;
  transition: all 0.2s ease;
`;

export const TabText = styled.p`
  color: ${({ $selected }) => ($selected ? "#142743" : "white")};
  font-family: Figtree;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.065px;
`;

export const Content = styled.div`
  padding: 0 16px;
  display: flex;

  @media (max-width: 340px) {
    display: unset;
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 12px;
  position: relative;
  min-height: 396px;
  width: 100%;
  @media (max-width: 768px) {
    height: unset;
    min-height: unset;
  }
`;

export const CategoryFadeWrapper = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 48px;
    background: linear-gradient(to right, transparent, #142743);
    pointer-events: none;
    transition: opacity 0.2s ease;
    opacity: ${({ $faded }) => ($faded ? 1 : 0)};
  }
`;

export const CategoryContainer = styled.div`
  display: flex;
  gap: 4px;
  padding: 0 16px;
  overflow-x: auto;
  scrollbar-width: none;
  flex-wrap: wrap;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const AdminActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 16px;
  flex-wrap: wrap;
`;

export const AdminActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #213d64;
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.06px;
  cursor: pointer;
  transition:
    opacity 0.2s ease,
    background 0.2s ease;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ $width }) => $width && `${$width}px`};
  justify-content: center;
  height: 22px;
  padding: 2px 4px;
  background-color: ${({ $selected, $click }) =>
    $selected ? "#345884" : $click ? "#fff" : "#112238"};
  border-radius: 8px;
  cursor: ${(p) => (p.$click ? "pointer" : "default")};
  border: 1px solid #345884;
  p {
    color: ${({ $selected, $click }) =>
      $selected ? "#fff" : $click ? "#112238" : "#fff"};
  }
  &:hover {
    background-color: ${({ $selected, $click }) =>
      $selected ? "#345884" : $click ? "#fff" : "#112238"};
  }
`;

export const CategoryText = styled.p`
  color: ${({ $selected }) => ($selected ? "#fff" : "#fff")};
  font-family: Figtree;
  font-size: 12px;
  font-weight: ${({ $selected }) => ($selected ? "600" : "500")};
  letter-spacing: -0.07px;
  white-space: nowrap;
`;

export const RightContent = styled.div`
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

export const StyledVideo = styled(Video)`
  height: 100%;
  width: unset;
  aspect-ratio: unset;
`;

export const StyledImage = styled(Image)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${(props) =>
    props.$hideImageContainer ? "transparent" : "#fff2"};
  max-width: 100%;

  img {
    border-radius: 12px;
    width: auto;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const RightContentOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 61.05%,
    rgba(0, 0, 0, 0.64) 100%
  );
`;

export const GenerateContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const GenerateButton = styled.button`
  width: 130px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  color: #0f2c32;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: -0.08px;
  padding-inline: 8px;
  margin: 0px 6px;
  flex: 1;

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding-inline: 4px;
    width: unset;
    font-size: 13px;
    margin-top: 6px;
    height: 34px;
  }
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const InfoIconWrapper = styled(StyledIconWrapper)`
  svg {
    path {
      stroke: ${(p) => (p.$active ? "rgba(63, 136, 247, 1)" : "#fff")};
    }
  }
`;

export const TooltipContainer = styled.div`
  border-radius: 16px;
  border: 1px solid #142743;
  background: #081120;
  padding: 16px;
  position: absolute;
  bottom: 24px;
  left: 0;
  width: 350px;
  gap: 8px;
  z-index: 100;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 290px;
    left: -255px;
  }
`;

export const TooltipText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
  opacity: ${(p) => (p.$light ? 0.56 : 1)};
`;

export const NudifyText = styled.div`
  font-family: Figtree;
  position: relative;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
`;

export const Badge = styled.div`
  transform: rotate(14.909deg);

  position: absolute;
  right: -24px;
  top: -8px;
`;

export const CheckboxContainerRow = styled.div`
  display: none;
  padding: 0 16px;
  gap: 6px;
  /* overflow-x: auto; */
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const FadeWrapper = styled.div`
  position: relative;
  width: 100%;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 16px;
    bottom: 0;
    width: 88px;
    background: linear-gradient(to right, transparent, #142743);
    pointer-events: none;
    transition: opacity 0.2s ease;
    opacity: ${({ $faded }) => ($faded ? 1 : 0)};
  }
  display: none;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const CheckboxContainer = styled.div`
  display: none;

  padding: 6px 8px;
  background: #0e1c31;
  border-radius: 12px;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  align-self: stretch;
  flex: 1;
  flex-direction: row;
  height: 33px;
  width: ${(p) => (p.$isExtendVideoTab ? "108px" : "unset")};
  flex: ${(p) => (!p.$isExtendVideoTab ? 1 : "unset")};

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const GenerateContainerMobile = styled.div`
  align-items: center;
  display: none;

  @media (max-width: 768px) {
    display: flex;
    padding: 0 16px;
    margin: 4px 0;
    margin-top: ${(p) => (p.$marginTop ? "32px" : "0px")};
  }
`;
